import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=39063e29&scoped=true&"
import script from "./CommentItem.vue?vue&type=script&lang=js&"
export * from "./CommentItem.vue?vue&type=script&lang=js&"
import style0 from "./CommentItem.vue?vue&type=style&index=0&id=39063e29&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39063e29",
  null
  
)

export default component.exports